import moment from 'moment';

const ConvertTimestampToDateTime = (timestamp) => {
	return moment.unix(timestamp / 1000).format('DD/MM/YYYY - HH:mm');
};

export default ConvertTimestampToDateTime;
